// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconLink = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M39.2509 24.7486C38.3783 23.876 37.2951 23.876 36.4225 24.7486L35.0083 26.1628C34.1356 27.0355 34.1356 28.1186 35.0083 28.9913C39.1463 33.1293 38.9891 37.7399 35.0083 41.7198L28.0362 48.6929C23.9912 52.7378 19.3521 52.7358 15.3081 48.6929C11.1624 44.5472 11.3354 39.9374 15.308 35.9648C16.1807 35.0922 16.1807 34.009 15.308 33.1364L13.8938 31.7222C13.0212 30.8495 11.938 30.8495 11.0654 31.7222C4.65463 38.1319 4.65463 46.5253 11.0654 52.9351C17.509 59.3787 25.8369 59.377 32.2788 52.9351L39.2509 45.962C45.6617 39.5523 45.6611 31.1588 39.2509 24.7486ZM24.7495 39.2509C25.6222 40.1235 26.7053 40.1235 27.578 39.2509L28.9922 37.8367C29.8648 36.9641 29.8648 35.8809 28.9922 35.0083C24.8541 30.8703 25.0113 26.2596 28.9922 22.2798L35.9643 15.3067C40.0092 11.2617 44.6484 11.2637 48.6923 15.3067C52.838 19.4524 52.6651 24.0621 48.6924 28.0347C47.8198 28.9074 47.8198 29.9905 48.6924 30.8632L50.1066 32.2774C50.9792 33.15 52.0624 33.15 52.935 32.2774C59.3458 25.8676 59.3458 17.4743 52.935 11.0645C46.4914 4.62088 38.1635 4.62259 31.7216 11.0645L24.7495 18.0376C18.3388 24.4472 18.3393 32.8408 24.7495 39.2509Z" />
    </svg>
  );
};
